import { Box, Button, Grid, IconButton, TextField, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import PageTitle from '../../components/page-title/PageTitle';
import { Container } from './FollowupList.styled';
import * as yup from 'yup';
import IFormError from '../../interfaces/IFormError';
import { useValidateSchema } from '../../hooks/providers/useValidateSchema';
import { AiFillCloseCircle } from 'react-icons/ai';

interface IProps {
  closeDialog: () => void;
  isOpen: boolean;
  medicalCertificateId: string;
  handleRequest: (eventDescription: string) => Promise<void>;
  statusMedicalCertificate: 'DISAPPROVED' | 'ARCHIVED' | 'DISAPPROVEDBYMANAGER' | 'ARCHIVEDBYMANAGER' | 'APPROVED';
}

const FollowupJustification = (props: IProps) => {
  const [errors, setErrors] = useState<IFormError | null>(null);
  const [justification, setJustification] = useState<string>('');

  const validation = useValidateSchema();

  const schema = yup.object({
    justification: yup
      .string()
      .required('Campo obrigatório')
      .min(1, 'Campo obrigatório'),
  });

  const handleSubmit = async () => {
    if (props.statusMedicalCertificate === 'DISAPPROVED' || props.statusMedicalCertificate === 'DISAPPROVEDBYMANAGER') {
      const result = await validation.validate(schema, { justification });
      setErrors(result.errors);
      if (!result.isValid) {
        return;
      }
    }

    if (props.statusMedicalCertificate === 'DISAPPROVED') {
      await props.handleRequest(`Documento reprovado pelo motivo: ${justification}`);
    } else if (props.statusMedicalCertificate === 'APPROVED') {
      await props.handleRequest(`Documento aprovado pelo motivo: ${justification}`);
    } else {
      await props.handleRequest(`Documento arquivado pelo motivo: ${justification}`);
    }
    props.closeDialog();
  };

  return (
    <Container>
      <PageTitle
        title={
          props.statusMedicalCertificate === 'DISAPPROVED' || props.statusMedicalCertificate === 'DISAPPROVEDBYMANAGER'
            ? 'JUSTIFICAR REPROVAÇÃO'
            : props.statusMedicalCertificate === 'APPROVED'
            ? 'JUSTIFICAR APROVAÇÃO'
            : 'JUSTIFICAR ARQUIVAMENTO'
        }
      >
        <Tooltip title="Fechar justificativa" placement="left">
          <IconButton onClick={() => props.closeDialog()}>
            <AiFillCloseCircle />
          </IconButton>
        </Tooltip>
      </PageTitle>
      <Grid container spacing={2} sx={{ padding: '20px 0px 20px 0px' }}>
        <Grid item sm={12} md={12} lg={12}>
          <TextField
            label="Justificativa"
            InputLabelProps={{ shrink: true }}
            placeholder={
              props.statusMedicalCertificate === 'DISAPPROVED'
                ? 'Informe porque esse documento está sendo reprovado.'
                : props.statusMedicalCertificate === 'APPROVED'
                ? 'Informe porque esse documento está sendo aprovado.'
                : 'Informe porque esse documento está sendo arquivado.'
            }
            fullWidth
            value={justification}
            onChange={e => setJustification(e.target.value)}
            error={Boolean(errors?.justification)}
            helperText={errors?.justification}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <Button onClick={() => props.closeDialog()} variant="contained" color="secondary" sx={{ marginRight: 2 }}>
          Cancelar
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Confirmar
        </Button>
      </Box>
    </Container>
  );
};

export default FollowupJustification;
